module.exports = __webpack_public_path__ + "static/img/event15.4616466.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event15.png
// module id = YrAR
// module chunks = 1